import React, { useState } from 'react';
import { ArrowRight, Menu, X } from 'lucide-react';
import { navLinks, APP_URL } from '../mock';
import VisualLogoMark from './VisualLogoMark';
import './VisualHomepage.css';

// Same header as the homepage (visual shell), pinned to the top on subpages.
const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="visual-header visual-header--fixed visual-header--subpage">
      <a href="/" className="visual-brand" aria-label="Tangibl3Net home">
        <VisualLogoMark />
        <span>Tangibl3Net</span>
      </a>
      <nav className="visual-nav" aria-label="Main navigation">
        {navLinks.map((l) => (
          <a key={l.label} href={l.href}>{l.label}</a>
        ))}
      </nav>
      <div className="visual-header__actions">
        <a className="visual-apply" href={APP_URL}>Apply now <ArrowRight size={17} /></a>
        <button
          className="visual-menu-button"
          type="button"
          onClick={() => setMobileOpen((open) => !open)}
          aria-label="Toggle navigation"
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? <X /> : <Menu />}
        </button>
      </div>
      {mobileOpen && (
        <nav className="visual-mobile-menu" aria-label="Mobile navigation">
          {navLinks.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setMobileOpen(false)}>{l.label}</a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Navbar;
